import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { useParams, useHistory } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { getBase64 } from "../../../helpers/FileToBase64";
import { formInputFields, validationSchema } from "./FormRightToWorkHelper";
import Label from "../../Layout/Label";
import Dropdown from "../../FormElements/Dropdown";
import Input from "../../FormElements/Input";
import Textarea from "../../FormElements/Textarea";
import UploadField from "../../FormElements/UploadField";
import { Button } from "react-bootstrap";

import constants from "../../../constants";
import {
  updateDataOnRequest,
  getDataOnRequest,
} from "../../../redux/actions/CommonActions";
import LoadFormFields from "../../Layout/LoadFormFields";
import { RightToworkDocumentsNewList } from "../../../helpers/DocumentsList";

const RightToWork = (props) => {
  const [rightToWorkData, setFormdata] = useState({});
  const { loader, userDetails, holiday, rightToWork } = props;
  const dispatch = useDispatch();
  const params = useParams();
  const history = useHistory();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    validateOnBlur,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onSubmit",
    reValidateMode: "onBlur",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    setFormdata(rightToWork);
    if (formInputFields(rightToWork).length > 0)
      formInputFields().map((field, key) => {
        if (rightToWork[field.name])
          setValue(field.name, rightToWork[field.name]);
      });
  }, [params.id, rightToWork]);
  const onSubmit = (e) => {
    e.preventDefault();
    let finalValid = false;
    let cnd_rightwork_document_master_id = document.getElementById(
      "cnd_rightwork_document_master_id"
    );
    let cnd_rightwork_document_master_id_msg = document.getElementById(
      "cnd_rightwork_document_master_id_msg"
    );
    let cnd_rightwork_upload_file = document.getElementById(
      "cnd_rightwork_upload_file"
    );
    let cnd_rightwork_upload_file_msg = document.getElementById(
      "cnd_rightwork_upload_file_msg"
    );
    let cnd_rightwork_expire_date = document.getElementById(
      "cnd_rightwork_expire_date"
    );
    let cnd_rightwork_expire_date_msg = document.getElementById(
      "cnd_rightwork_expire_date_msg"
    );
    let cnd_rightwork_document_number = document.getElementById(
      "cnd_rightwork_document_number"
    );
    let cnd_rightwork_document_number_msg = document.getElementById(
      "cnd_rightwork_document_number_msg"
    );
    let cnd_rightwork_description = document.getElementById(
      "cnd_rightwork_description"
    );
    let cnd_rightwork_description_msg = document.getElementById(
      "cnd_rightwork_description_msg"
    );

    if (cnd_rightwork_document_master_id) {
      if (!cnd_rightwork_document_master_id.value) {
        cnd_rightwork_document_master_id.classList.add("border-danger");
        if (cnd_rightwork_document_master_id_msg)
          cnd_rightwork_document_master_id_msg.innerText =
            "Please select the document type";
        finalValid = true;
      } else {
        cnd_rightwork_document_master_id.classList.remove("border-danger");
        if (cnd_rightwork_document_master_id_msg)
          cnd_rightwork_document_master_id_msg.innerText = "";
      }
    }

    if (cnd_rightwork_upload_file) {
      if (
        !cnd_rightwork_upload_file.value &&
        !rightToWorkData.cnd_rightwork_upload_file
      ) {
        cnd_rightwork_upload_file.classList.add("border-danger");
        if (cnd_rightwork_upload_file_msg)
          cnd_rightwork_upload_file_msg.innerText = "Please select the document";
        finalValid = true;
      } else {
        cnd_rightwork_upload_file.classList.remove("border-danger");
        if (cnd_rightwork_upload_file_msg)
          cnd_rightwork_upload_file_msg.innerText = "";
      }
    }

    if (cnd_rightwork_expire_date) {
      let expDate = new Date(String(cnd_rightwork_expire_date.value));
      let currentDate = new Date(new Date().toISOString().split("T")[0]);
      if (!cnd_rightwork_expire_date.value) {
        cnd_rightwork_expire_date.classList.add("border-danger");
        if (cnd_rightwork_expire_date_msg)
          cnd_rightwork_expire_date_msg.innerText = "Please select the expiry date";
        finalValid = true;
      } else if (
        cnd_rightwork_expire_date.value &&
        !String(cnd_rightwork_expire_date.value).match(
          /^(19|20)\d\d[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])$/
        )
      ) {
        cnd_rightwork_expire_date.classList.add("border-danger");
        if (cnd_rightwork_expire_date_msg)
          cnd_rightwork_expire_date_msg.innerText =
            "Please select the date in dd-mm-yyyy format";
        finalValid = true;
      } else if (cnd_rightwork_expire_date.value && expDate < currentDate) {
        cnd_rightwork_expire_date.classList.add("border-danger");
        if (cnd_rightwork_expire_date_msg)
          cnd_rightwork_expire_date_msg.innerText =
            "Please select the current or after date";
        finalValid = true;
      } else {
        cnd_rightwork_expire_date.classList.remove("border-danger");
        if (cnd_rightwork_expire_date_msg)
          cnd_rightwork_expire_date_msg.innerText = "";
      }
    }

    if (cnd_rightwork_document_number) {
      if (
        !cnd_rightwork_document_number.value ||
        cnd_rightwork_document_number.value.trim() == ""
      ) {
        cnd_rightwork_document_number.classList.add("border-danger");
        if (cnd_rightwork_document_number_msg)
          cnd_rightwork_document_number_msg.innerText =
            "Please enter the document reference number";
        finalValid = true;
      } else if (
        cnd_rightwork_document_number.value &&
        !cnd_rightwork_document_number.value.match(/^[0-9a-zA-Z \b]+$/)
      ) {
        cnd_rightwork_document_number.classList.add("border-danger");
        if (cnd_rightwork_document_number_msg)
          cnd_rightwork_document_number_msg.innerText =
            "Special character not allowed";
        finalValid = true;
      } else {
        cnd_rightwork_document_number.classList.remove("border-danger");
        if (cnd_rightwork_document_number_msg)
          cnd_rightwork_document_number_msg.innerText = "";
      }
    }

    if (cnd_rightwork_description) {
      if (
        cnd_rightwork_description.value &&
        cnd_rightwork_description.value.trim() == ""
      ) {
        cnd_rightwork_description.classList.add("border-danger");
        if (cnd_rightwork_description_msg)
          cnd_rightwork_description_msg.innerText =
            "Please enter the valid description";
        finalValid = true;
      } else {
        cnd_rightwork_description.classList.remove("border-danger");
        if (cnd_rightwork_description_msg)
          cnd_rightwork_description_msg.innerText = "";
      }
    }
    let allData = rightToWorkData;
    // console.log("All Data Are :=>"+JSON.stringify(rightToWorkData));

    // console.log("File Is :=>"+allData['cnd_rightwork_upload_file']);
    allData["users_access_token"] = userDetails.users_access_token;
    if (rightToWork.cnd_rightwork_id)
      allData["cnd_rightwork_id"] = rightToWork.cnd_rightwork_id;

    if (finalValid == false) {
       console.log("Final Payload:", allData);
      document.getElementById("loader").style.display = "block";
      // Clear the RTW update in progress flag after successful submission
      localStorage.removeItem('rtwUpdateInProgress');
      dispatch(
        updateDataOnRequest(
          JSON.stringify(allData, null, 2),
          "updateRightToWork",
          "",
          getDataOnRequest(
            userDetails.users_access_token,
            "SetRightToWorks",
            "SET_RIGHT_TO_WORKS"
          )
        )
      );
    }
    dispatch(
      getDataOnRequest(
        props.userDetails.users_access_token,
        "ProgressBar",
        "SET_PROGRESS"
      )
    );
    //history.push('/right-to-work');
  };

  const onChangeInputvalue = async (e) => {
    // e.preventDefault();

    if (e.target.name === "cnd_rightwork_upload_file") {
      if (e.target.files && e.target.files[0]) {
        setFormdata({
          ...rightToWorkData,
          [e.target.name]: await getBase64(e.target.files[0]),
        });
      } else if (e.target.value) {
        setFormdata({
          ...rightToWorkData,
          [e.target.name]: e.target.value,
        });
      }
    } else {
      setFormdata({
        ...rightToWorkData,
        [e.target.name]: e.target.value,
      });
    }

    let finalValid = false;
    let cnd_rightwork_document_master_id = document.getElementById(
      "cnd_rightwork_document_master_id"
    );
    let cnd_rightwork_document_master_id_msg = document.getElementById(
      "cnd_rightwork_document_master_id_msg"
    );
    let cnd_rightwork_upload_file = document.getElementById(
      "cnd_rightwork_upload_file"
    );
    let cnd_rightwork_upload_file_msg = document.getElementById(
      "cnd_rightwork_upload_file_msg"
    );
    let cnd_rightwork_expire_date = document.getElementById(
      "cnd_rightwork_expire_date"
    );
    let cnd_rightwork_expire_date_msg = document.getElementById(
      "cnd_rightwork_expire_date_msg"
    );
    let cnd_rightwork_document_number = document.getElementById(
      "cnd_rightwork_document_number"
    );
    let cnd_rightwork_document_number_msg = document.getElementById(
      "cnd_rightwork_document_number_msg"
    );
    let cnd_rightwork_description = document.getElementById(
      "cnd_rightwork_description"
    );
    let cnd_rightwork_description_msg = document.getElementById(
      "cnd_rightwork_description_msg"
    );

    if (cnd_rightwork_document_master_id) {
      if (!cnd_rightwork_document_master_id.value) {
        cnd_rightwork_document_master_id.classList.add("border-danger");
        if (cnd_rightwork_document_master_id_msg)
          cnd_rightwork_document_master_id_msg.innerText =
            "Please select the document type";
      } else {
        cnd_rightwork_document_master_id.classList.remove("border-danger");
        if (cnd_rightwork_document_master_id_msg)
          cnd_rightwork_document_master_id_msg.innerText = "";
      }
    }

    if (cnd_rightwork_upload_file) {
      if (
        !cnd_rightwork_upload_file.value &&
        !rightToWorkData.cnd_rightwork_upload_file
      ) {
        cnd_rightwork_upload_file.classList.add("border-danger");
        if (cnd_rightwork_upload_file_msg)
          cnd_rightwork_upload_file_msg.innerText = "Please select the document";
      } else {
        cnd_rightwork_upload_file.classList.remove("border-danger");
        if (cnd_rightwork_upload_file_msg)
          cnd_rightwork_upload_file_msg.innerText = "";
      }
    }

    if (cnd_rightwork_expire_date) {
      let expDate = new Date(String(cnd_rightwork_expire_date.value));
      let currentDate = new Date(new Date().toISOString().split("T")[0]);
      if (!cnd_rightwork_expire_date.value) {
        cnd_rightwork_expire_date.classList.add("border-danger");
        if (cnd_rightwork_expire_date_msg)
          cnd_rightwork_expire_date_msg.innerText = "Please select the expiry date";
      } else if (
        cnd_rightwork_expire_date.value &&
        !String(cnd_rightwork_expire_date.value).match(
          /^(19|20)\d\d[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])$/
        )
      ) {
        cnd_rightwork_expire_date.classList.add("border-danger");
        if (cnd_rightwork_expire_date_msg)
          cnd_rightwork_expire_date_msg.innerText =
            "Please select the date in dd-mm-yyyy format";
      } else if (cnd_rightwork_expire_date.value && expDate < currentDate) {
        cnd_rightwork_expire_date.classList.add("border-danger");
        if (cnd_rightwork_expire_date_msg)
          cnd_rightwork_expire_date_msg.innerText =
            "Please select the current or after date";
      } else {
        cnd_rightwork_expire_date.classList.remove("border-danger");
        if (cnd_rightwork_expire_date_msg)
          cnd_rightwork_expire_date_msg.innerText = "";
      }
    }

    if (cnd_rightwork_document_number) {
      if (
        !cnd_rightwork_document_number.value ||
        cnd_rightwork_document_number.value.trim() == ""
      ) {
        cnd_rightwork_document_number.classList.add("border-danger");
        if (cnd_rightwork_document_number_msg)
          cnd_rightwork_document_number_msg.innerText =
            "Please enter the document reference number";
      } else if (
        cnd_rightwork_document_number.value &&
        !cnd_rightwork_document_number.value.match(/^[0-9a-zA-Z \b\-]+$/)
      ) {
        cnd_rightwork_document_number.classList.add("border-danger");
        if (cnd_rightwork_document_number_msg)
          cnd_rightwork_document_number_msg.innerText =
            "Special character not allowed";
      } else {
        cnd_rightwork_document_number.classList.remove("border-danger");
        if (cnd_rightwork_document_number_msg)
          cnd_rightwork_document_number_msg.innerText = "";
      }
    }

    if (cnd_rightwork_description) {
      if (
        cnd_rightwork_description.value &&
        cnd_rightwork_description.value.trim() == ""
      ) {
        cnd_rightwork_description.classList.add("border-danger");
        if (cnd_rightwork_description_msg)
          cnd_rightwork_description_msg.innerText =
            "Please enter the valid description";
      } else {
        cnd_rightwork_description.classList.remove("border-danger");
        if (cnd_rightwork_description_msg)
          cnd_rightwork_description_msg.innerText = "";
      }
    }

    // console.log("Set Format Data :=> "+JSON.stringify(rightToWorkData));

    // console.log("Data Are  :=>" + JSON.stringify(rightToWorkData));
  };

  // Useffect For Scroll Start

  const isMobileOrLaptop = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile =
      /mobile|android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
        userAgent
      );

    if (isMobile) {
      return "Mobile";
    } else {
      const isTablet = /android|ipad|tablet/i.test(userAgent);
      if (isTablet) {
        return "Tablet";
      } else {
        return "Laptop/Desktop";
      }
    }
  };
  let scrollFocusElement;
  useEffect(() => {
    scrollFocusElement = document.getElementById("scrollFocusElement");
    const deviceType = isMobileOrLaptop();
    // console.log('Device Type:', deviceType);
    if (deviceType == "Mobile" || deviceType == "Tablet") {
      window.scrollTo(0, 900);
    }
  }, [scrollFocusElement]);
  // UseEffect For Scroll Stop
console.log( ' right to work data is :=> ', rightToWorkData);
  return (
    <React.Fragment>
      <div className="job-bx submit-resume" id="scrollFocusElement">
        <div className="job-bx-title clearfix">
          <h5 className="font-weight-700 pull-left text-uppercase">
            Right To Work
          </h5>
        </div>
        <form noValidate onSubmit={onSubmit}>
          {/* <LoadFormFields
            register={register}
            errors={errors}
            formInputFields={formInputFields()}
            onChangeInputvalue={(e) => onChangeInputvalue(e)}
            reset={reset}
            data={rightToWorkData}
            documentUrl={constants.IMAGE_URL+rightToWork.cnd_rightwork_folder_path+rightToWork.cnd_rightwork_upload_file}
            backButton={true}
            backUrl={"/right-to-work"}
          /> */}

          {/* <div className="container"> */}
          <div className="row">
            <div className="col-sm-6">
              <Dropdown
                label="Select Documents"
               value={rightToWorkData.cnd_rightwork_document_master_id || ""}
                // disabled={rightToWork.cnd_rightwork_document_master_id ? true : false}
                options={RightToworkDocumentsNewList}
                name="cnd_rightwork_document_master_id"
                id="cnd_rightwork_document_master_id"
                changeHandler={(e) => onChangeInputvalue(e)}
                lg={12}
              />
            </div>
            <div className="col-sm-6">
              <UploadField
                label="Upload File"
                name="cnd_rightwork_upload_file"
                id="cnd_rightwork_upload_file"
                value={rightToWorkData.cnd_rightwork_upload_file}
                changeHandler={(e) => onChangeInputvalue(e)}
                lg={12}
                req={true}
                acceptedTypes={["pdf", "image"]}
              />
            </div>
            <div className="col-sm-6">
              <Input
                label="Expiry Date"
                name="cnd_rightwork_expire_date"
                id="cnd_rightwork_expire_date"
                type="date"
                min={new Date().toISOString().split("T")[0]}
                className="form-control"
                value={rightToWork.cnd_rightwork_expire_date}
                changeHandler={(e) => onChangeInputvalue(e)}
                lg={12}
              />
            </div>
            <div className="col-sm-6">
              <Input
                label="Document Number"
                name="cnd_rightwork_document_number"
                id="cnd_rightwork_document_number"
                type="text"
                className="form-control"
                value={rightToWork.cnd_rightwork_document_number}
                changeHandler={(e) => onChangeInputvalue(e)}
                placeholder="Enter document number"
                lg={12}
              />
            </div>
            <div className="col-sm-12">
              <Textarea
                label="Document Description"
                name="cnd_rightwork_description"
                id="cnd_rightwork_description"
                type="text"
                className="form-control"
                placeholder="Enter Document Description"
                lg={12}
                value={rightToWork.cnd_rightwork_description}
                changeHandler={(e) => onChangeInputvalue(e)}
                req={false}
              />
              <Button
                className="site-button m-b30 float-right mr-3"
                type="submit"
              >
                Save
              </Button>
              <a
                href="/right-to-work"
                className="site-button text-white yellow m-b30 float-right mr-3"
                type="button"
              >
                Back
              </a>
            </div>
          </div>
          {/* </div> */}
        </form>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    errors: state.error.error,
    loader: state.loader.loader,
    userDetails: state.auth.authUserData,
    userProfileData: state.userProfile.userData,
    rightToWork: state.rightToWork.rightToWork,
  };
};
export default connect(mapStateToProps)(RightToWork);
